import { render, staticRenderFns } from "./Clone.vue?vue&type=template&id=6859adcf&scoped=true&"
import script from "./Clone.vue?vue&type=script&lang=js&"
export * from "./Clone.vue?vue&type=script&lang=js&"
import style0 from "./Clone.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Clone.vue?vue&type=style&index=1&id=6859adcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859adcf",
  null
  
)

export default component.exports